import * as React from "react";
const SvgButtonRankings = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 140 140",
	...props
}, /* @__PURE__ */ React.createElement("g", {
	fill: "none",
	stroke: "#000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	transform: "scale(5.83333)"
}, /* @__PURE__ */ React.createElement("rect", {
	x: .75,
	y: 15.75,
	width: 5.25,
	height: 7.5,
	rx: .75
}), /* @__PURE__ */ React.createElement("rect", {
	x: 18,
	y: 17.75,
	width: 5.25,
	height: 5.5,
	rx: .75
}), /* @__PURE__ */ React.createElement("rect", {
	x: 9.37,
	y: 12.75,
	width: 5.25,
	height: 10.5,
	rx: .75
}), /* @__PURE__ */ React.createElement("path", { d: "m12.91 1.08 1.24 2.45h2.13a.59.59 0 0 1 .42 1l-1.95 1.92 1.08 2.48a.59.59 0 0 1-.84.74L12.38 8.2 9.76 9.67a.59.59 0 0 1-.84-.74L10 6.45 8.05 4.53a.59.59 0 0 1 .42-1h2.13l1.24-2.45a.6.6 0 0 1 1.07 0Z" })));
export { SvgButtonRankings as ReactComponent };
